var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4c0-2.209 1.791-4 4-4h27.2c2.209 0 4 1.791 4 4v17.6c0 2.209-1.791 4-4 4h-2.4v4.8c0 0.63-0.37 1.201-0.945 1.46s-1.248 0.155-1.718-0.264l-6.745-5.996h-15.392c-2.209 0-4-1.791-4-4v-17.6zM4 3.2c-0.442 0-0.8 0.358-0.8 0.8v17.6c0 0.442 0.358 0.8 0.8 0.8h16c0.392 0 0.77 0.144 1.063 0.404l4.537 4.033v-2.837c0-0.884 0.716-1.6 1.6-1.6h4c0.442 0 0.8-0.358 0.8-0.8v-17.6c0-0.442-0.358-0.8-0.8-0.8h-27.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 9.6c0-0.884 0.716-1.6 1.6-1.6h14.4c0.884 0 1.6 0.716 1.6 1.6s-0.716 1.6-1.6 1.6h-14.4c-0.884 0-1.6-0.716-1.6-1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 16c0-0.884 0.716-1.6 1.6-1.6h9.6c0.884 0 1.6 0.716 1.6 1.6s-0.716 1.6-1.6 1.6h-9.6c-0.884 0-1.6-0.716-1.6-1.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.af8cae17.svg";
export { ForwardRef as ReactComponent };